export const assetsUrl = __ENDPOINTS_HOST__

const isAbsoluteOrDataUrl = (url: string): boolean => /^(?:https?:)?\/\//i.test(url) || url.startsWith('data:')

export const resolveRelativeAssetUrl = (url?: string | null): string | undefined => {
    if (!url) {
        return
    }
    return isAbsoluteOrDataUrl(url) ? url : `${assetsUrl}${url.startsWith('/') ? url : `/${url}`}`
}
